module.exports = __webpack_public_path__ + "img/baby.dca73d6b.svg";